import * as yup from 'yup';
import { useTranslation } from "react-i18next";

export default function AdminUsersValidation(): any {
    const { t } = useTranslation('validation');

    return yup.object().shape({
        userId: yup.string().required(t('addAdmin.RequiredUser'))
    });
}
